import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='validationDelegate' subtitle='PrimerHeadlessValidatableDelegate' mdxType="Item">
Validation delegate will be triggered every time collected data is updated.
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`  func didUpdate(validationStatus: PrimerValidationStatus, for data: PrimerCollectableData?)
`}</code></pre>
      <Item title='PrimerValidationStatus' subtitle='Enum' mdxType="Item">
        <p><inlineCode parentName="p">{`PrimerValidationStatus`}</inlineCode>{` is an enum that represents the different validation statuses in the Primer SDK. It helps to communicate the state of validation for a particular process, providing clear categorization of validation states.`}</p>
        <Group summary='enum PrimerValidationStatus' mdxType="Group">
  <Item title='validating' mdxType="Item">
    Enum case representing the ongoing validation state.
    This indicates that the validation process is currently in progress.
  </Item>
  
  <Item title='valid' mdxType="Item">
    Enum case representing a successful validation state.
    This indicates that the validation process has completed successfully and the data is valid.
  </Item>
  
  <Item title='invalid' mdxType="Item">
    Enum case representing an unsuccessful validation state due to validation errors.
    This indicates that the validation process has completed but has found one or more errors in the data.
    <Group summary='Associated Value' open mdxType="Group">
      <Item title='errors' subtitle='[PrimerValidationError]' mdxType="Item">
        An array of `PrimerValidationError` representing the specific validation errors found.
      </Item>
    </Group>
  </Item>
  
  <Item title='error' mdxType="Item">
    Enum case representing an error state due to an unexpected issue.
    This indicates that an unexpected error has occurred during the validation process.
    <Group summary='Associated Value' open mdxType="Group">
      <Item title='error' subtitle='PrimerError' mdxType="Item">
        A `PrimerError` representing the unexpected error that occurred.
      </Item>
    </Group>
  </Item>
        </Group>
      </Item>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      